import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Accordion } from '../components/accordion/accordion';
import { AccordionItem } from '../components/accordion/accordion-item';
import { Alert, AlertVariant } from '../components/alert/alert';
import { Breadcrumbs } from '../components/breadcrumbs/breadcrumbs';
import { Button } from '../components/button/button';
import { LotCard } from '../components/card/lot-card';
import { CheckBox } from '../components/checkbox/checkbox';
import { Container } from '../components/container/container';
import { Header } from '../components/header/header';
import { Image } from '../components/image/image';
import { Label, LabelVariant } from '../components/label/label';
import { LegoGroup } from '../components/lego/lego-group';
import { LegoItem } from '../components/lego/lego-item';
import { LotDetails } from '../components/lot/lot-details';
import { Modal } from '../components/modal/modal';
import { Radio } from '../components/radio/radio';
import { Range } from '../components/range/range';
import { RulesItem } from '../components/rules/rules-item';
import { SearchBox } from '../components/search-box/search-box';
import { Skeleton } from '../components/skeleton/skeleton';
import { Status } from '../components/status/status';
import AuctionSvg from '../components/svg/auction';
import CheckedSvg from '../components/svg/checked';
import DashboardsSvg from '../components/svg/dashboard';
import LogoSvg from '../components/svg/logo';
import PaddleSvg from '../components/svg/paddle';
import UserSvg from '../components/svg/user';
import { Table } from '../components/table/table';
import { Tbody } from '../components/table/tbody';
import { Td } from '../components/table/td';
import { Th } from '../components/table/th';
import { Thead } from '../components/table/thead';
import { Tr } from '../components/table/tr';
import { Timer } from '../components/timers/timer';

export function Lego() {
  const [openedModal, setOpenedModal] = useState(false);
  return (
    <>
      <Container>
        <LegoItem title="Header not auth">
          <Header
            isAuthenticated={false}
            logo={
              <Link to="/">
                <LogoSvg />
              </Link>
            }
            userIcon={<UserSvg />}
          />
        </LegoItem>

        <LegoItem title="Header Auth">
          <Header
            isAuthenticated={true}
            logo={
              <Link to="/">
                <LogoSvg />
              </Link>
            }
            userIcon={<UserSvg />}
          />
        </LegoItem>
        <LegoItem title="Buttons">
          <LegoGroup title="Small">
            <Button variant="primary" size="sm">
              Primary
            </Button>
            <Button variant="secondary" size="sm">
              Secondary
            </Button>
            <Button variant="tertiary" size="sm">
              Tertiary
            </Button>
            <Button variant="gold" size="sm">
              Gold
            </Button>
          </LegoGroup>
          <LegoGroup title="Medium">
            <Button variant="primary">Primary</Button>
            <Button variant="secondary">Secondary</Button>
            <Button variant="tertiary">Tertiary</Button>
            <Button variant="gold">Gold</Button>
          </LegoGroup>
          <LegoGroup title="Large">
            <Button variant="primary" size="lg">
              Primary
            </Button>
            <Button variant="secondary" size="lg">
              Secondary
            </Button>
            <Button variant="tertiary" size="lg">
              Tertiary
            </Button>
            <Button variant="gold" size="lg">
              Gold
            </Button>
          </LegoGroup>
          <LegoGroup title="Loading">
            <Button variant="primary" loading>
              Primary
            </Button>
            <Button variant="secondary" loading>
              Secondary
            </Button>
            <Button variant="tertiary" loading>
              Tertiary
            </Button>
            <Button variant="gold" loading>
              Gold
            </Button>
          </LegoGroup>
        </LegoItem>

        <LegoItem title="Search box">
          <SearchBox placeholder="Search Sotheby’s" />
        </LegoItem>

        <LegoItem title="Table">
          <div style={{ maxWidth: '375px' }}>
            <Table>
              <Thead>
                <Tr>
                  <Th>Paddle</Th>
                  <Th>Time</Th>
                  <Th>Amount</Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr isActive>
                  <Td>213</Td>
                  <Td>Just now</Td>
                  <Td>700 USD</Td>
                </Tr>
                <Tr>
                  <Td>12</Td>
                  <Td>1 min. ago</Td>
                  <Td>650 USD</Td>
                </Tr>
                <Tr>
                  <Td>41</Td>
                  <Td>3 min. ago</Td>
                  <Td>600 USD</Td>
                </Tr>
                <Tr>
                  <Td>55</Td>
                  <Td>4 min. ago</Td>
                  <Td>500 USD</Td>
                </Tr>
                <Tr>
                  <Td>61</Td>
                  <Td>4 min. ago</Td>
                  <Td>400 USD</Td>
                </Tr>
                <Tr>
                  <Td>42</Td>
                  <Td>5 min. ago</Td>
                  <Td>350 USD</Td>
                </Tr>
                <Tr>
                  <Td>99</Td>
                  <Td>5 min. ago</Td>
                  <Td>300 USD</Td>
                </Tr>
                <Tr>
                  <Td>15</Td>
                  <Td>6 min. ago</Td>
                  <Td>250 USD</Td>
                </Tr>
                <Tr>
                  <Td>21</Td>
                  <Td>6 min. ago</Td>
                  <Td>100 USD</Td>
                </Tr>
              </Tbody>
            </Table>
          </div>
        </LegoItem>

        <LegoItem title="Timer">
          <Timer value={new Date()} text="Until Live Auction" />
        </LegoItem>

        <LegoItem title="Lot Details">
          <LotDetails
            isLoading={false}
            image={<Image src="./temp/wine_temp.png" alt="" />}
            brandName="213.  Blackbird Vineyards"
            title="2019 Blackbird Arise"
            summary="This classic Napa blend is primarily comprised of Cabernet Sauvignon, Merlot and Cabernet Franc. It’s elegance and purity of flavor come from exceptional vineyards, minimal winemaking intervention, a deep..."
            highestBid={800}
          />
        </LegoItem>

        <LegoItem title="Loading Lot Details">
          <div style={{ maxWidth: '375px' }}>
            <LotDetails
              isLoading={true}
              image={<Image src="./temp/wine_temp.png" alt="" />}
              brandName="213.  Blackbird Vineyards"
              title="2019 Blackbird Arise"
              summary="This classic Napa blend is primarily comprised of Cabernet Sauvignon, Merlot and Cabernet Franc. It’s elegance and purity of flavor come from exceptional vineyards, minimal winemaking intervention, a deep..."
              highestBid={800}
            />
          </div>
        </LegoItem>

        <LegoItem title="Accordion">
          <Accordion>
            <AccordionItem title="Details">
              <h2>Description</h2>
              <p>
                Officia tempor nostrud elit mollit aute dolore fugiat cillum
                enim. Duis deserunt qui sit labore exercitation consectetur
                pariatur duis irure eu incididunt laboris.
              </p>
              <h2>Sale contents</h2>
              <p>
                Officia tempor nostrud elit mollit aute dolore fugiat cillum
                enim. Duis deserunt qui sit labore exercitation consectetur
                pariatur duis irure eu incididunt laboris.
              </p>
            </AccordionItem>
          </Accordion>
        </LegoItem>

        <LegoItem title="Lot Card">
          <div style={{ maxWidth: '750px' }}>
            <LotCard
              status={
                <Label variant={LabelVariant.Warning}>You were overbid</Label>
              }
              image={<Image src="./temp/image_example_tall_2.png" alt="" />}
              brandName="213.  Blackbird Vineyards"
              title="2019 Blackbird Arise"
              highestBid={1200}
            />
          </div>
        </LegoItem>

        <LegoItem title="Loading Lot Card">
          <div style={{ maxWidth: '750px' }}>
            <LotCard
              isLoading
              status={
                <Label variant={LabelVariant.Warning}>You were overbid</Label>
              }
              image={<Image src="./temp/image_example_tall_2.png" alt="" />}
              brandName="213.  Blackbird Vineyards"
              title="2019 Blackbird Arise"
              highestBid={1200}
              summary="2019 Blackbird"
            />
          </div>
        </LegoItem>

        <LegoItem title="Status">
          <Status>You have the high bid</Status>
        </LegoItem>

        <LegoItem title="Alert">
          <Alert
            variant={AlertVariant.Info}
            title="1 hour remaining"
            copy={
              'Upper limits on bids have been lifted. You are free to bid lorem ipsum dolor sit amet.'
            }
          />
          <br />
          <Alert
            variant={AlertVariant.Success}
            title="1 hour remaining"
            copy={
              'Upper limits on bids have been lifted. You are free to bid lorem ipsum dolor sit amet.'
            }
          />
          <br />
          <Alert
            variant={AlertVariant.Danger}
            title="1 hour remaining"
            copy={
              'Upper limits on bids have been lifted. You are free to bid lorem ipsum dolor sit amet.'
            }
          />
          <br />
          <Alert
            variant={AlertVariant.Warning}
            title="1 hour remaining"
            copy={
              'Upper limits on bids have been lifted. You are free to bid lorem ipsum dolor sit amet.'
            }
          />
        </LegoItem>

        <LegoItem title="Label">
          <Label>Lot 214</Label> <br />
          <br />
          <Label variant={LabelVariant.Warning}>Lot 214</Label>
        </LegoItem>

        <LegoItem title="Breadcrumb">
          <Breadcrumbs>
            <p>Lot 123</p>
            <p>Leaderboard</p>
          </Breadcrumbs>
        </LegoItem>

        {/* <LegoItem title="Bid Sheet">
          <BidSheet
            title="Bidding on lot 214"
            highestBid={700}
            info="You can bid 750 - 1.200 USD in 50 USD increments."
          />
        </LegoItem>

        <LegoItem title="Bid Sheet message unsuccessful">
          <BidSheet
            title="Bid was unsuccessful"
            highestBid={700}
            info="You can bid 750 - 1.200 USD in 50 USD increments."
            message="Your bid of 750 USD is no longer valid because the current highest bid has increased to 750 USD. You can choose to bid 800 USD or to cancel. We need some better copy for this error message."
          />
        </LegoItem>

        <LegoItem title="Bid Sheet message successful">
          <BidSheet
            title="Success"
            highestBid={700}
            info="You can bid 750 - 1.200 USD in 50 USD increments."
            message="Your bid of 750 USD is no longer valid because the current highest bid has increased to 750 USD. You can choose to bid 800 USD or to cancel. We need some better copy for this error message."
          />
        </LegoItem>
          */}

        <LegoItem title="Checkbox">
          <CheckBox>Test</CheckBox>
          <CheckBox defaultChecked>Test</CheckBox>
          <CheckBox disabled>Test</CheckBox>
          <CheckBox checked disabled>
            Test
          </CheckBox>
        </LegoItem>

        <LegoItem title="Radio Group">
          <Radio name="demo" label="Lot number - Ascending" defaultChecked />
          <Radio name="demo" label="Lot number - Descending" />

          <Radio label="Lot number - Ascending" checked={false} disabled />
          <Radio label="Lot number - Descending" checked disabled />
        </LegoItem>

        <LegoItem title="Range">
          <Range
            min={0}
            max={1000}
            onChange={({ min, max }: { min: number; max: number }) =>
              console.log(`min = ${min}, max = ${max}`)
            }
          />
        </LegoItem>

        <LegoItem title="Placeholder">
          <Skeleton height={30} width={150} visible />
        </LegoItem>

        <LegoItem title="Modal">
          <Button onClick={() => setOpenedModal(true)}>Open Modal</Button>
          <AnimatePresence initial={false}>
            {openedModal && (
              <Modal
                title="Welcome to the Leaderboard"
                onClose={() => setOpenedModal(false)}
                action={<Button>Go to My Lots</Button>}
              >
                <p>
                  Thank you for placing a bid. Your bid is among the ten bids on
                  the leaderboard. The top ten bids will win a case of the wine.
                  Good luck!
                </p>
              </Modal>
            )}
          </AnimatePresence>
        </LegoItem>
        <LegoItem title="Paddle Item">
          <RulesItem
            leftIcon={<PaddleSvg />}
            title="Leaderboard auction"
            copy="This ia leaderboad auction where the top 10 bids win the lot."
            rightIcon={<CheckedSvg />}
          />
          <RulesItem
            leftIcon={<DashboardsSvg />}
            title="Dashboard"
            copy="All bids are displayed in real-time on the vintners screen at the event."
            rightIcon={<CheckedSvg />}
          />
          <RulesItem
            leftIcon={<AuctionSvg />}
            title="Charity auction"
            copy="This is a charity auction meaning that all profits will be donated to charities. Amounts exceeding the lots’ Estimate can be declared as charitable donations."
            rightIcon={<CheckedSvg />}
          />
        </LegoItem>
      </Container>
    </>
  );
}
